// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__30uWC","inner":"Footer_inner__27tG_"};